<template>
    <div>
        <sav-template :title="$t('mes_produits.produit.mes_produits')" :back-button="false">
            <sav-spinner more-class="mb-3" v-show="loadergetData" />
            <template v-if="!loadergetData && data">
                <template v-for="(productData, productDataIndex) in data">
                    <template v-if="data[productDataIndex].length > 0">
                        <div class="mb-16" :key="'product-' + productDataIndex">
                            <!-- Title -->
                            <div class="mb-3 text-lg font-bold flex items-center">
                                <div :class="dataLabel[productDataIndex].color" class="mr-2 h-3 w-3 rounded-full"></div>
                                {{dataLabel[productDataIndex].label}}
                            </div>
                            <!-- Product cards -->
                            <div class="mb-3" v-for="(product, productIndex) in data[productDataIndex]" :key="'product-' + productIndex">
                                <sav-fold-card :title="'<span class=\'text-lg font-extrabold\'>' + product.product.marque + ' - ' + (product.product.libelle || product.product.model) + '</span>'" :id="'product-card-' + productIndex" v-model="product.isOpen" :test-id="'product-card-' + productIndex">
                                    <!-- Close -->
                                    <template v-slot:close>
                                        <div class="flex items-center justify-between">
                                            <div>
                                                <div class="flex items-center">
                                                    <img class="h-10" :src="product.product.categoryIcon" alt="">
                                                    <div class="ml-5">
                                                        <div>
                                                            <h5 class="capitalize font-bold">
                                                                <b class="font-black uppercase">{{product.product.marque}}</b>
                                                                <span class="mx-1">-</span>
                                                                <span>{{product.product.libelle || product.product.model}}</span>
                                                            </h5>
                                                        </div>
                                                        <div v-if="product.lastUpdate.date" class="text-sm font-light opacity-70 mt-0.5">{{ $tt('Dernière modification le') }} {{product.lastUpdate.date | moment}}</div>
                                                        <div v-if="product.product.date_ha || product.product.num_serie" class="text-xs font-light opacity-80 mb-1">
                                                            <span v-if="product.product.date_ha">{{ $tt('Acheté le') }} {{product.product.date_ha | moment}}</span>
                                                            <span v-if="product.product.date_ha && product.product.num_serie" class="mx-2">|</span>
                                                            <span v-if="product.product.num_serie">{{ $tt('Numéro de série') }}: {{product.product.num_serie}}</span>
                                                        </div>
                                                        <div v-if="product.lastUpdate.state == 1" class="mt-2">
                                                            <span class="p-1 px-3 rounded-xl text-xs text-white bg-orange-500"><i class="fas fa-exclamation-triangle mr-1"></i> {{$tt(product.action.label)}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <template v-if="product && product.id_case && product.id_case.length > 0">
                                                    <div class="mt-2 bg-gray-100 p-4 rounded-xl">
                                                        <badge-state :state="product.etat" :label="product.id_case[0].statut" :date="product.id_case[0].date_maj" />
                                                    </div>
                                                </template>
                                            </div>
                                            <i class="fas fa-angle-right"></i>
                                        </div>
                                    </template>
                                    <template v-slot:open>
                                        <hr class="my-5">
                                        <!-- Product detail -->
                                        <div class="mb-5" v-if="product.lastUpdate.state == 1">
                                            <h6 class="font-bold mb-3">{{ $tt('Action à effectuer') }}</h6>
                                            <!-- Actions -->
                                            <template v-if="product.action.id == 'att_devis'">
                                                <accept-devis-action
                                                :id-case="product.action.id_case"
                                                :file-url="product.action.documents.find((doc) => doc.type == 'Devis').url"
                                                />
                                            </template>
                                            <template v-else-if="product.action.id == 'paye'">
                                                <pay-form-action
                                                :id-case="product.action.id_case"
                                                />
                                            </template>
                                            <template v-else-if="product.action.id == 'attente_doc_client'">
                                                <div class="bg-orange-200 text-orange-900 p-4 rounded mb-2">
                                                    <div class="font-bold text-xl"><i class="fas fa-exclamation-triangle mr-1"></i> {{$t('mes_produits.upload_doc.une_action_est_requise_de_votre_part')}}</div>
                                                    <div>{{ $tt('Merci de compléter la demande de complément ci-dessous') }}</div>
                                                </div>
                                                <!-- TOKEN URL -->
                                                <iframe class="w-full border h-[610px] mb-20" :src="complementBaseUrl + '/widget/complements/' + product.action.token + '?height=450px'" frameborder="0"></iframe>
                                                <!-- ID URL -->
                                                <!-- <iframe class="w-full border h-[610px] mb-20" :src="complementBaseUrl + '/widget/complements/' + product.action.id_case + '?height=450px'" frameborder="0"></iframe> -->
                                            </template>
                                            <div v-else class="text-white font-bold bg-orange-400 p-4 rounded-xl">
                                                {{$tt(product.action.label)}}
                                            </div>
                                        </div>
                                        <!-- Product detail -->
                                        <!-- <div class="mb-5">
                                            <h6 class="font-bold">Informations produit</h6>
                                            <product-card class="mt-3" :data="product" />
                                        </div> -->
                                        <!-- Dossiers -->
                                        <div v-if="product.cases.length == 0" class="mb-2 text-xl font-bold text-gray-500">
                                            {{$t('mes_produits.produit.aucun_dossier_pour_ce_produit')}}
                                        </div>
                                        <template v-if="product.cases.length > 0">
                                            <div class="mb-2">
                                                <h6 class="font-bold" v-if="product.cases.length <= 1">{{$t('mes_produits.produit.mon_dossier')}}</h6>
                                                <h6 class="font-bold" v-else>{{$t('mes_produits.produit.mes_dossiers')}}</h6>
                                            </div>
                                            <div v-if="product.cases.length == 1" class="border bg-gray-50 p-4 rounded-xl">
                                                <folder-card-content
                                                class="mt-3 mb-5"
                                                :id="product.cases[0].id"
                                                :state="product.lastUpdate.state"
                                                :product-data="product"
                                                :case-data="product.cases[0]"
                                                :status="product.cases[0].statut"
                                                :date-last-maj="product.cases[0].date_maj"
                                                :folder-number="product.cases[0].num_case"
                                                />
                                            </div>
                                            <div v-else>
                                                <div v-for="(caseData, caseIndex) in product.cases" :key="'case-' + caseIndex">
                                                    <folder-card
                                                    class="mt-3 mb-5"
                                                    :id="caseData.id"
                                                    :state="product.lastUpdate.state"
                                                    :product-data="product"
                                                    :case-data="caseData"
                                                    :status="caseData.statut"
                                                    :date-last-maj="caseData.date_maj"
                                                    :folder-number="caseData.num_case"
                                                    />
                                                </div>
                                            </div>
                                        </template>
                                        <button v-if="product.cases.length <= 0 || product.lastUpdate.state == 2" @click="createSavCase(product)" class="px-3 py-2 mt-3 text-sm font-light text-white duration-100 bg-green-500 hover:bg-green-600 rounded-xl">
                                            <small>
                                                <i class="mr-1 fas fa-redo"></i>{{$t('mes_produits.produit.nouvelle_demande_sur_ce_produit')}}
                                            </small>
                                        </button>
                                    </template>
                                </sav-fold-card>
                            </div>
                        </div>
                    </template>
                </template>
                <template v-if="data && (data.nothings.length <= 0 && data.waitings.length <= 0 && data.ends.length <= 0)">
                    <div class="bg-white border rounded-xl p-5 shadow font-light">
                        {{$t('mes_produits.produit.aucun_produit')}}
                    </div>
                </template>
            </template>
        </sav-template>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import eventHub from '@/eventHub'
import env from '@/../.env'

import moment from 'moment'

import FolderCard from './FolderCard.vue'
import ProductCard from './ProductCard.vue'
import FolderCardContent from './FolderCardContent.vue'

import AcceptDevisAction from './FolderActions.vue/AcceptDevisAction.vue'
import PayFormAction from './FolderActions.vue/PayFormAction.vue'
import WaitingDocument from './FolderActions.vue/WaitingDocument.vue'

export default {
    components: {FolderCard, FolderCardContent, ProductCard, AcceptDevisAction, PayFormAction, WaitingDocument},

    data() {
        return {
            loadergetData: false,
            data: null,
        }
    },

    computed: {
        dataLabel() {
            return {
                nothings: {label: this.$tt('En cours de traitement'), color: 'bg-gray-500'},
                waitings: {label: this.$tt('Vous avez une action à effectuer'), color: 'bg-orange-500'},
                ends: {label: this.$tt('Terminés'), color: 'bg-green-500'}
            }
        },

        onDemo() {
            return apiService.onDemo()
        },

        complementBaseUrl() {
            if (this.onDemo) {
                return env.URL_DISTRIADMIN_DEMO
            } else {
                return env.URL_DISTRIADMIN
            }
        }
    },

    methods: {
        async getProducts(){
            this.loadergetData = true

            // Get all products
            const client_id = this.$crypto.decrypt(localStorage.getItem('client_id'))
            let response = await apiService.post('getappconso', {
                id_conso: client_id
            })
            const responseData = response.data.posts.post

            // Parse data
            this.data = {
                waitings: [],
                nothings: [],
                ends: []
            }
            let endObj = null
            for await (let data of responseData) {
                // Get first folder data
                let folderData = null
                if (data.cases.length > 0 && data.etat == 1) {
                    folderData = await apiService.post('getdetailcase', {
                        id_case: data.cases[0].id
                    })
                    folderData = folderData.data.posts.post
                }

                // Normalize data
                endObj = {
                    isOpen: false,
                    product: {
                        model: data['Modele'],
                        libelle: data['Libelle'],
                        marque: data['Marque'],
                        ean: data['Ean'],
                        num_serie: data.num_serie && data.num_serie != 'null' ? data.num_serie : null,
                        categoryIcon: data.default_case.groupe ? data.default_case.groupe.img : null,
                        date_ha: data.date_ha && data.date_ha != '0000-00-00' ? data.date_ha : null
                    },
                    shop: {
                        cp: data.default_case.magasin.cp,
                        id: data.default_case.magasin.id,
                        name: data.default_case.magasin ? data.default_case.magasin.name : '',
                        ville: data.default_case.magasin ? data.default_case.magasin.ville : '',
                        fullAddress: data.default_case.magasin.ville + ' ' + data.default_case.magasin.cp,
                        sign: {
                            logo: data.default_case.enseigne ? data.default_case.enseigne.img : '',
                            name: data.default_case.enseigne ? data.default_case.enseigne.name : data.default_case.enseigne
                        }
                    },
                    lastUpdate: {
                        date: data.cases.length > 0 ? data.cases[0].date_maj : null,
                        state: data.etat,
                    },
                    action: {
                        id_case: folderData ? folderData.id : null,
                        id: folderData ? folderData.id_dsc_etat : null,
                        label: folderData ? folderData.last_statut : null,
                        comment: folderData ? folderData.comment : null,
                        documents: folderData ? folderData.documents : null,
                        token: folderData ? folderData.token : null,
                    },
                    default_case: data.default_case,
                    cases: data.cases
                }

                // Push obj in data
                if (endObj.lastUpdate.state !== null) {
                    if (endObj.lastUpdate.state == 0) {
                        this.data.nothings.push(endObj)
                    } else if (endObj.lastUpdate.state == 1) {
                        this.data.waitings.push(endObj)
                    } else if (endObj.lastUpdate.state == 2) {
                        this.data.ends.push(endObj)
                    }
                } else {
                    this.data.ends.push(endObj)
                }
            }

            this.loadergetData = false
        },

        createSavCase(item) {
            let data = item.default_case
            console.log(data);
            let setForms = [
                {
                    storageName: 'brand', apiKeyname: 'marque',
                    renames: [{api: 'marque', storage: 'label'}],
                    default: null,
                },
                {
                    storageName: 'category', apiKeyname: 'groupe',
                    renames: [{api: 'group_name', storage: 'label'}],
                    default: null
                },
                {
                    storageName: 'device', apiKeyname: 'modele',
                    renames: [],
                    default: []
                },
                {
                    storageName: 'sign', apiKeyname: 'enseigne',
                    renames: [{api: 'name', storage: 'label'}],
                    default: null
                },
                {
                    storageName: 'shop', apiKeyname: 'magasin',
                    renames: [],
                    default: []
                }
            ]

            // Clear form
            localStorage.setItem('form-data', JSON.stringify({temp: {}}))

            // Init form
            this.$nextTick(async () => {
                setForms.forEach((form) => {
                    // Rename keys
                    form.renames.forEach((rename) => {
                        if (data[form.apiKeyname]) {
                            data[form.apiKeyname][rename.storage] = data[form.apiKeyname][rename.api]
                            delete data[form.apiKeyname][rename.api]
                        }
                    })
    
                    // Transform end value
                    let endObject = data[form.apiKeyname]
                    if (form.default) {
                        endObject = [{value: data[form.apiKeyname]}]
                    }
    
                    // Set in storage
                    this.$formTool.addFormData(form.storageName, endObject)
                })
    
                // Set specific data
                // 1. shop
                let shop = this.$formTool.getFormData('shop')
                shop[0].value.img = this.$formTool.getFormData('sign') ? this.$formTool.getFormData('sign').img : ''
                shop[0].value.townAndZipCode = this.$addressTool.capitalizeTown(shop[0].value.ville) + shop[0].value.cp
                let response = await apiService.post('getshop', {id_enseigne: this.$formTool.getFormData('sign').id})
                if (response.data.posts.post.length == 0 && response.data.posts.id_mag) {
                    shop = [{type: 'auto', value: {id: response.data.posts.id_mag}}]
                }
                this.$formTool.addFormData('shop', shop)

                // 2. device
                let device = this.$formTool.getFormData('device')
                device.modelDescription = device.description
                device.moreData = device['Modele']
                this.$formTool.addFormData('device', device)

                // Redirect
                this.$router.push({name: 'form.home'})
            })
        },
    },

    filters: {
        moment(date) {
            return moment(date).format('DD/MM/YYYY');
        }
    },

    mounted() {
        this.getProducts()

        eventHub.$on('refresh-product', async (data) => {
            await this.getProducts()
        })

        window.addEventListener("message", async (event) => {            
            if (event.data && event.data.from && event.data.from == 'complements') {
                switch (event.data.type) {
                    case 'form-sended':
                        await this.getProducts()
                        break;
                    case 'msg-sended':
                        await this.getProducts()
                        break;
                }
            }
        }, false);        
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/companies/default/views/user/product/List.vue